import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["to", "className", "ariaLabel", "label"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _isEmpty from 'lodash/isEmpty';
import { getValidProps } from '../../modules/foundation/services/props';
export function arePathsEqual(path1, path2) {
  function cleanPathName() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return path.replace(/^\/|\/$/g, '');
  }
  return cleanPathName(path1) === cleanPathName(path2);
}
export function getInternalLinkProps() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    to = _ref.to,
    className = _ref.className,
    ariaLabel = _ref.ariaLabel,
    label = _ref.label,
    rest = _objectWithoutProperties(_ref, _excluded);
  var validProps = ['id', 'ref', 'activeClassName', 'activeStyle', 'onClick', 'partiallyActive', 'replace', 'state', 'role', 'aria-label', 'aria-labelledby', 'aria-selected', 'aria-expanded', 'aria-checked', 'aria-busy', 'style'];
  var validRestProps = getValidProps(rest, validProps);
  var options = _objectSpread({
    to: to,
    activeClassName: 'active',
    activeStyle: {
      textDecoration: 'underline',
      textUnderlinePosition: 'under'
    }
  }, validRestProps);
  if (!_isEmpty(className)) {
    options = _objectSpread(_objectSpread({}, options), {}, {
      className: className
    });
  }
  var finalAriaLabel = ariaLabel || label || '';
  if (!_isEmpty(finalAriaLabel)) {
    options = _objectSpread(_objectSpread({}, options), {}, {
      'aria-label': finalAriaLabel
    });
  }
  return options;
}